import AccountSettings from './AccountSettings';
export { AccountSettings };
export default AccountSettings;
